<i18n src="@/lang/protocols.yaml"></i18n>

<template lang="pug">
.d-inline-block.text-left
    //- Button
    button.btn.btn-secondary(@click="showModal = true") Haustyp-Assistent starten

    //- Modal
    .modal-backdrop.fade.show(v-if="showModal")
    .modal(:class="{ 'd-block': showModal }")
        .modal-dialog.modal-dialog-scrollable.modal-md: .modal-content
            header.modal-header
                h5.modal-title Haustyp-Assistent
                button.close(type="button", @click="showModal = false") &times;

            .modal-body
                //- nach2002 Formgroup
                .form-group.mb-4
                    label.label-title Gebäude errichtet nach 2002? (ENEV 2002)
                    div
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_nach2002`",
                                type="radio",
                                v-model="nach2002",
                                :value="true"
                            )
                            label.custom-control-label(:for="`${_uid}_nach2002`") ja, nach 2002
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_vor2002`",
                                type="radio",
                                v-model="nach2002",
                                :value="false"
                            )
                            label.custom-control-label(:for="`${_uid}_vor2002`") nein, vor 2002

                //- freieLueftung Formgroup
                .form-group.border-top.my-4(v-if="nach2002 === true")
                    label.label-title Welche Lüftung wurde bauseitig eingebaut?
                    help-text-modal(:body="$t('modals.housetype.freieLueftung.helptext')")
                    div
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_freieLueftung1`",
                                type="radio",
                                v-model="freieLueftung",
                                :value="true"
                            )
                            label.custom-control-label(:for="`${_uid}_freieLueftung1`") Freie Lüftung
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_freieLueftung0`",
                                type="radio",
                                v-model="freieLueftung",
                                :value="false"
                            )
                            label.custom-control-label(:for="`${_uid}_freieLueftung0`") Ventilator-gestützt

                //- wesentlicheAenderungen Formgroup
                .form-group.border-top.my-4(v-if="nach2002 === false")
                    label.label-title Wurden wesentliche Änderungen der Luftdurchlässigkeit an der Gebäudehülle vorgenommen?
                    div
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_wesentlicheAenderungen1`",
                                type="radio",
                                v-model="wesentlicheAenderungen",
                                :value="true"
                            )
                            label.custom-control-label(:for="`${_uid}_wesentlicheAenderungen1`") Ja, wesentliche Änderungen vorhanden
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_wesentlicheAenderungen0`",
                                type="radio",
                                v-model="wesentlicheAenderungen",
                                :value="false"
                            )
                            label.custom-control-label(:for="`${_uid}_wesentlicheAenderungen0`") Nein, keine Änderungen vorhanden

                //- einfamilienhaus Formgroup
                .form-group.border-top.my-4(v-if="nach2002 === false && wesentlicheAenderungen === true")
                    label.label-title Handelt es sich um ein Einfamilienhaus?
                    div
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_einfamilienhaus1`",
                                type="radio",
                                v-model="einfamilienhaus",
                                :value="true"
                            )
                            label.custom-control-label(:for="`${_uid}_einfamilienhaus1`") Ja, es ist ein Einfamilienhaus
                        .custom-control.custom-control-inline.custom-radio
                            input.custom-control-input(
                                :id="`${_uid}_einfamilienhaus0`",
                                type="radio",
                                v-model="einfamilienhaus",
                                :value="false"
                            )
                            label.custom-control-label(:for="`${_uid}_einfamilienhaus0`") Nein, es ist ein Mehrfamilienhaus

                //- HausType Result
                .alert.alert-info.text-center.my-4(v-if="haustyp") Ermittelter Haustyp: {{ haustyp }}

            footer.modal-footer
                button.btn.btn-secondary(type="button", @click="showModal = false") Abbrechen
                button.btn.btn-primary(@click="updateHaustyp", :disabled="!haustyp") Haustyp übernehmen
</template>

<script>
import HelpTextModal from '@/components/HelpTextModal'

export default {
    components: {
        HelpTextModal
    },
    props: {
        mehrgeschossig: {
            type: Boolean
        },
        value: {
            type: Number,
            default: null
        }
    },
    data () {
        return {
            showModal: false,
            nach2002: undefined,
            freieLueftung: undefined,
            wesentlicheAenderungen: undefined,
            einfamilienhaus: undefined
        }
    },
    computed: {
        haustyp () {
            if (this.nach2002 === true) {
                if (this.freieLueftung === true) {
                    if (this.mehrgeschossig === true) {
                        return 4
                    } else if (this.mehrgeschossig === false) {
                        return 3
                    }
                } else if (this.freieLueftung === false) {
                    if (this.mehrgeschossig === true) {
                        return 2
                    } else if (this.mehrgeschossig === false) {
                        return 1
                    }
                }
            } else if (this.nach2002 === false) {
                if (this.wesentlicheAenderungen === true) {
                    if (this.mehrgeschossig === true) {
                        if (this.einfamilienhaus === true) {
                            return 6
                        } else if (this.einfamilienhaus === false) {
                            return 4
                        }
                    } else if (this.mehrgeschossig === false) {
                        if (this.einfamilienhaus === true) {
                            return 5
                        } else if (this.einfamilienhaus === false) {
                            return 3
                        }
                    }
                } else if (this.wesentlicheAenderungen === false) {
                    return 7
                }
            }
            return null
        }
    },
    methods: {
        updateHaustyp () {
            if (this.haustyp !== null) {
                this.$emit('input', this.haustyp)
                this.showModal = false
            }
        }
    }
}
</script>
